import { datadogLogs } from "@datadog/browser-logs";

export let intervalId = null;

export function initLoginTracking(userId) {
  console.log("initLoggingTracking start");
  const maxAttempts = 6; // Define the maximum number of attempts
  let attempt = 1;
  let interval = 1;
  const INTERVAL_MIN = 2;

  intervalId = setInterval(() => {
    if (attempt > maxAttempts) {
      clearInterval(intervalId);
      return;
    }

    const intervalToCheck = Math.pow(2, attempt - 1);
    // console.log("intervalToCheck", intervalToCheck)
    // checking only exponentially
    if (intervalToCheck === interval) {
      const minToWait = interval * INTERVAL_MIN;
      if (process.env.VUE_APP_DATADOG_CLIENT_TOKEN) {
        const message = `User (auth0Id: ${userId}) still in login screen in ${minToWait} min `;
        const data = { auth0Id: userId, logType: "login" };
        if (attempt === maxAttempts) {
          datadogLogs.logger.error(message, data);
        } else {
          datadogLogs.logger.warn(message, data);
        }
      }
      attempt += 1;
    }
    // console.log("interval:", interval);
    // console.log("attempt:", attempt);

    interval += 1;
  }, INTERVAL_MIN * 1000); // Initial check interval
}

export function clearLoginInterval(userId) {
  try {
    if (intervalId) {
      console.log("clearLoginInterval start");
      const data = { auth0Id: userId, logType: "login" };
      const message = `User (auth0Id: ${userId}) has successfully login`;
      datadogLogs.logger.info(message, data);
      clearInterval(intervalId);
      intervalId = null;
    }
  } catch {
    console.error("Error in clearing Login Interval");
  }
}
